import { ModuleBase } from "@/modules/base";
import { Component, Mixins } from 'vue-property-decorator';
import Window from './Window.vue';

@Component
export class AboutModule extends Mixins(ModuleBase) {
  show = false

  get outlet() {
    return {
      window: Window,
    }
  }
}
